import { Message } from 'element-ui'

/**
 * 提示信息
 * @param msg 提示信息
 * @param type 显示消息的类型 success/warning/info/error
 */
export function msg(msg, type) {
  Message({
    message: msg,
    type: type,
    duration: 3 * 1000
  })
}

/**
 * 获取response 不是分页的情况下 get
 * msg 执行的提示信息
 * @param response http response
 * @return null or data
 */
export function getData(response) {
  if (response.code === '0') {
    return response.data ? response.data : null
  } else {
    if (response.msg !== undefined) {
      msg(response.msg, 'error')
    }
  }
  return null
}

/**
 * 获取response 分页情况下的数据 get 并不会返回total
 * msg 执行的提示信息
 * @param response http response
 * @return null or data
 */
export function getPageData(response) {
  if (response.code === '0') {
    return response.data.records ? response.data.records : null
  } else {
    msg(response.msg, 'error')
  }
  return null
}

/**
 *针对于post del 的方式 提示和返回数据
 * msg 执行的提示信息
 * @param response http response
 * @return null or data
 */
export function getPostOrDeleteData(response) {
  if (response.code === '0') {
    msg(response.msg, 'success')
    return response.data ? response.data : null
  } else {
    msg(response.msg, 'error')
  }
  return null
}
